(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE_BREAKPOINT = 860;

  function initSection(root) {
    var viewport = root.querySelector('[data-modulo-ps-viewport]');
    var track = root.querySelector('[data-modulo-ps-track]');
    if (!viewport || !track) {
      console.warn('[modulo-ps] init skipped: missing viewport or track', { viewport: !!viewport, track: !!track });
      return;
    }
    console.log('[modulo-ps] initSection — items:', track.children.length, 'root:', root);

    var prevBtn = root.querySelector('[data-modulo-ps-prev]');
    var nextBtn = root.querySelector('[data-modulo-ps-next]');
    var fill = root.querySelector('[data-modulo-ps-fill]');
    var currentEl = root.querySelector('[data-modulo-ps-current]');
    var totalEl = root.querySelector('[data-modulo-ps-total]');

    var cardsDesktop = parseInt(root.getAttribute('data-cards-desktop'), 10) || 5;
    var cardsMobile = parseInt(root.getAttribute('data-cards-mobile'), 10) || 2;
    var totalItems = track.children.length;
    var currentIndex = 0;

    function cardsPerView() {
      return window.innerWidth <= MOBILE_BREAKPOINT ? cardsMobile : cardsDesktop;
    }

    function maxIndex() {
      return Math.max(0, totalItems - cardsPerView());
    }

    function itemWidth() {
      if (track.children.length === 0) return 0;
      var first = track.children[0];
      var rect = first.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '12') || 12;
      return rect.width + gap;
    }

    function update() {
      var max = maxIndex();
      if (currentIndex > max) currentIndex = max;
      if (currentIndex < 0) currentIndex = 0;

      var offset = currentIndex * itemWidth();
      if (REDUCE) {
        track.style.transition = 'none';
      }
      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';

      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= max;

      if (fill) {
        var totalPages = max + 1;
        var fillPercent = totalPages <= 1 ? 100 : ((currentIndex + 1) / totalPages) * 100;
        fill.style.width = fillPercent + '%';
      }

      if (currentEl) {
        var visiblePosition = currentIndex + 1;
        currentEl.textContent = visiblePosition < 10 ? '0' + visiblePosition : String(visiblePosition);
      }
      if (totalEl) {
        totalEl.textContent = totalItems < 10 ? '0' + totalItems : String(totalItems);
      }
    }

    function step(direction) {
      var jump = cardsPerView();
      currentIndex += direction * jump;
      update();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    // Pointer swipe — capture ONLY when drag threshold crossed, so taps/clicks
    // on child links flow naturally through to navigation.
    var pointerStartX = null;
    var pointerStartY = null;
    var pointerDragging = false;
    var pointerId = null;
    var DRAG_ACTIVATE = 6;
    var SWIPE_THRESHOLD = 40;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerStartX = e.clientX;
      pointerStartY = e.clientY;
      pointerId = e.pointerId;
      pointerDragging = false;
      var targetDesc = e.target.tagName + (e.target.getAttribute && e.target.getAttribute('class') ? '.' + e.target.getAttribute('class').split(' ')[0] : '');
      console.log('[modulo-ps] pointerdown at', e.clientX, 'target:', targetDesc);
    });

    viewport.addEventListener('pointermove', function (e) {
      if (pointerStartX === null) return;
      var dx = e.clientX - pointerStartX;
      var dy = e.clientY - pointerStartY;

      // Activate drag only when horizontal move dominates and crosses threshold
      if (!pointerDragging && Math.abs(dx) > DRAG_ACTIVATE && Math.abs(dx) > Math.abs(dy)) {
        pointerDragging = true;
        try { viewport.setPointerCapture(pointerId); } catch (_) {}
        console.log('[modulo-ps] drag started, capturing pointer');
      }
      if (pointerDragging) e.preventDefault();
    });

    viewport.addEventListener('pointerup', function (e) {
      if (pointerStartX === null) return;
      var dx = e.clientX - pointerStartX;
      var wasDragging = pointerDragging;
      pointerStartX = null;
      pointerStartY = null;
      pointerDragging = false;

      if (wasDragging) {
        try { viewport.releasePointerCapture(pointerId); } catch (_) {}
        pointerId = null;
        if (Math.abs(dx) >= SWIPE_THRESHOLD) {
          console.log('[modulo-ps] swipe fired, dx=', dx);
          step(dx < 0 ? 1 : -1);
        }
      } else {
        pointerId = null;
        console.log('[modulo-ps] pointerup without drag — click will fire normally');
      }
    });

    viewport.addEventListener('pointercancel', function () {
      pointerStartX = null;
      pointerStartY = null;
      pointerDragging = false;
      pointerId = null;
    });

    // Debug: log any click reaching the viewport so we can see what target is resolving
    viewport.addEventListener('click', function (e) {
      var target = e.target;
      var anchor = target.closest ? target.closest('a') : null;
      console.log('[modulo-ps] click on', target.tagName, target.className, '→ anchor href:', anchor ? anchor.href : '(none)');
    });

    // Keyboard navigation on the viewport
    viewport.setAttribute('tabindex', '0');
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { step(-1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { step(1);  e.preventDefault(); }
    });

    // Resize handler (debounced)
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // Clamp currentIndex to new maxIndex based on new cardsPerView
        update();
      }, 120);
    });

    // Quick-add buttons (only the cart-add ones — links to PDP handle themselves)
    var addButtons = root.querySelectorAll('[data-modulo-ps-add]');
    for (var j = 0; j < addButtons.length; j++) {
      addButtons[j].addEventListener('click', handleQuickAdd);
    }

    // Initial render
    update();
  }

  function handleQuickAdd(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var variantId = btn.getAttribute('data-modulo-ps-add');
    console.log('[modulo-ps] quick-add clicked. variantId=', variantId, 'disabled=', btn.disabled);
    if (!variantId || btn.disabled) {
      console.warn('[modulo-ps] quick-add skipped (no variantId or disabled)');
      return;
    }

    btn.disabled = true;
    btn.classList.remove('is-added', 'is-error');
    btn.classList.add('is-loading');

    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';
    var payload = { items: [{ id: variantId, quantity: 1 }] };
    console.log('[modulo-ps] POST', url, payload);

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        console.log('[modulo-ps] response status=', r.status, r.statusText, 'url=', r.url);
        if (!r.ok) {
          return r.text().then(function (txt) {
            console.error('[modulo-ps] cart/add FAILED. body:', txt);
            var parsed;
            try { parsed = JSON.parse(txt); } catch (_) { parsed = { message: txt }; }
            throw parsed;
          });
        }
        return r.json();
      })
      .then(function (data) {
        console.log('[modulo-ps] cart/add SUCCESS:', data);
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (_) { /* older browsers */ }
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function (err) {
        console.error('[modulo-ps] cart/add ERROR:', err);
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.disabled = false;
        }, 2000);
      });
  }

  function bootstrap() {
    var els = document.querySelectorAll('[data-modulo-ps]');
    console.log('[modulo-ps] bootstrap — found', els.length, 'section(s). moduloLazyInit present?', !!window.moduloLazyInit);
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-ps]', initSection);
    } else {
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
